import { CDN_URL } from '../../../modules/vars'
import { CDN_HOME_URL_PREFIX } from './home.constants'

export const CDN_NAVIGATION_URL_PREFIX = `${CDN_URL}/web/ab-test/landing-home/navigation`

export const IMG_NAVIGATION_RINGLE_LOGO = `${CDN_HOME_URL_PREFIX}/ringle-logo.svg`
export const IMG_NAVIGATION_MENU_ICON = `${CDN_HOME_URL_PREFIX}/menu-icon.svg`

export const IMG_NAVIGATION_HOME_ICON_ACTIVE = `${CDN_NAVIGATION_URL_PREFIX}/home-icon-active.svg`
export const IMG_NAVIGATION_MATERIAL_ICON_ACTIVE = `${CDN_NAVIGATION_URL_PREFIX}/material-icon-active.svg`
export const IMG_NAVIGATION_TUTOR_ICON_ACTIVE = `${CDN_NAVIGATION_URL_PREFIX}/tutor-icon-active.svg`
export const IMG_NAVIGATION_PRICING_ICON_ACTIVE = `${CDN_NAVIGATION_URL_PREFIX}/pricing-icon-active.svg`
export const IMG_NAVIGATION_HELP_ICON_ACTIVE = `${CDN_NAVIGATION_URL_PREFIX}/help-icon-active.svg`
export const IMG_NAVIGATION_PROMOTION_ICON_ACTIVE = `${CDN_NAVIGATION_URL_PREFIX}/promotion-icon-active.svg`

export const IMG_NAVIGATION_HOME_ICON_INACTIVE = `${CDN_NAVIGATION_URL_PREFIX}/home-icon-inactive.svg`
export const IMG_NAVIGATION_MATERIAL_ICON_INACTIVE = `${CDN_NAVIGATION_URL_PREFIX}/material-icon-inactive.svg`
export const IMG_NAVIGATION_TUTOR_ICON_INACTIVE = `${CDN_NAVIGATION_URL_PREFIX}/tutor-icon-inactive.svg`
export const IMG_NAVIGATION_PRICING_ICON_INACTIVE = `${CDN_NAVIGATION_URL_PREFIX}/pricing-icon-inactive.svg`
export const IMG_NAVIGATION_HELP_ICON_INACTIVE = `${CDN_NAVIGATION_URL_PREFIX}/help-icon-inactive.svg`
export const IMG_NAVIGATION_PROMOTION_ICON_INACTIVE = `${CDN_NAVIGATION_URL_PREFIX}/promotion-icon-inactive.svg`
